export const skillTypeRTL = {
  initial: { opacity: 1, x: 200, color: "#5AC9DB" },
  whileinview: {
    opacity: 0.7,
    x: 0,
    color: "#DBCD5A",
    transition: { duration: 1, delay: 0.1, type: "spring", bounce: 0.25 },
  },
};

export const skillTypeLTR = {
  initial: { opacity: 1, x: -200, color: "#DBCD5A" },
  whileinview: {
    opacity: 0.7,
    x: 0,
    color: "#5AC9DB",
    transition: { duration: 1, delay: 0.2, type: "spring", bounce: 0.25 },
  },
};
